// src\components\ProdMgrs\components\ProdMgrsRepSelector.jsx

import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import useProdMgrsRepOptions from '../hooks/useProdMgrsRepOptions.js';

function ProdMgrsRepSelector({ selectedYear, selectedRep, onRepChange }) {
  const { options, loading } = useProdMgrsRepOptions(selectedYear);

  // Keep current rep unless it doesn't exist in the new year's options
  React.useEffect(() => {
    if (!selectedRep) {
      return;
    }
    if (options.length > 0 && !options.includes(selectedRep)) {
      onRepChange('');
    }
  }, [options, selectedRep, onRepChange]);

  return (
    <FormControl>
      <InputLabel id="pmgr-rep-label-id">Rep</InputLabel>
      <Select
        label="Rep"
        labelId="pmgr-rep-label-id"
        size="small"
        value={selectedRep || ''}
        onChange={(e) => onRepChange(e.target.value)}
        sx={{ height: '3.125rem', mx: 0, padding: '0.625rem', minWidth: '12rem' }}
        data-cy="rep-select"
        disabled={loading}
        renderValue={(v) => v || ''}
      >
        {options.map((repid, idx) => (
          <MenuItem key={repid} value={repid} data-cy={`rep-select-${idx}`}>
            {repid}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

ProdMgrsRepSelector.propTypes = {
  selectedYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  selectedRep: PropTypes.string,
  onRepChange: PropTypes.func.isRequired,
};

export default React.memo(ProdMgrsRepSelector);
